import { IconButton } from "@material-ui/core";
import { GroopitFilterAssignmentDisplayDTO } from "groopit-js/client";
import React from "react";
import { createFilterRemoveAssignmentAction } from "../State/FilterActions";
import { DeleteOutlined } from "@material-ui/icons";
import { useFilterDispatchContext } from "../State/FilterDispatchContext";

interface StaleAssignmentFilterProps {
  assignmentFilter: GroopitFilterAssignmentDisplayDTO;
}

export const StaleAssignmentFilter = (props: StaleAssignmentFilterProps) => {
  const { assignmentFilter } = props;
  const { filterDispatcher } = useFilterDispatchContext();

  return (
    <div>
      <div className="flex flex-row items-center space-x-3 p-2">
        <img
          src={assignmentFilter.assignmentPhotoUrl}
          className="assignment-img-small"
          alt="Data model icon"
        />
        <div className="flex-grow text-app-gray-06">
          <span className="font-bold">{assignmentFilter.title}</span> (
          {"\u26a0"} deleted)
        </div>
        <IconButton
          color="secondary"
          onClick={() => {
            filterDispatcher(
              createFilterRemoveAssignmentAction(assignmentFilter.id),
            );
          }}
          size="small"
          title="Remove data model filter"
          aria-label="Remove data model filter"
        >
          <DeleteOutlined />
        </IconButton>
      </div>
    </div>
  );
};
